import {
    SET_ACTIVE_PAGE_INDEX,
    SET_NAVIGATION_DONE,
    NAVIGATE_TO_BIASHARA_FLEXI_QUOTE,
    SET_LANDING_PAGE,
    NAVIGATE_TO_LANDING_PAGE,
    NAVIGATE_TO_COMPANY_DETAILS,
    NAVIGATE_TO_EMPLOYEE_DETAILS,
    NAVIGATE_TO_UPLOAD_DOCUMENTS,
    NAVIGATE_TO_PAYMENT,
} from '../../actions/biasharaFlexi/routing';
import { PAGE_INDICES } from '../../actions/biasharaFlexi/types';

export const initRouting = {
    activePageIndex: 0,
    doNavigation: false,
    doExitNavigation: false,
    landingPage: null,
};



export default (state = initRouting, action) => {

    const setActivePage = (pageIndex) => ({
        ...state,
        activePageIndex: pageIndex,
        doNavigation: true,
    });

    switch (action.type) {
        case SET_ACTIVE_PAGE_INDEX:
            return {
                ...state,
                doNavigation: true,
                activePageIndex: action.value,
            };
        case SET_NAVIGATION_DONE:
            return { ...state, doNavigation: false };
        case NAVIGATE_TO_BIASHARA_FLEXI_QUOTE:
            return setActivePage(PAGE_INDICES.QOUTE);
        case SET_LANDING_PAGE:
            return { ...state, landingPage: action.value };
        case NAVIGATE_TO_LANDING_PAGE:
            return setActivePage(PAGE_INDICES.LANDING_PAGE);
        case NAVIGATE_TO_COMPANY_DETAILS:
            return setActivePage(PAGE_INDICES.COMPANY_DETAILS);
        case NAVIGATE_TO_EMPLOYEE_DETAILS:
            return setActivePage(PAGE_INDICES.EMPLOYEE_DETAILS);
        case NAVIGATE_TO_UPLOAD_DOCUMENTS:
            return setActivePage(PAGE_INDICES.UPLOAD_DOCUMENTS);
        case NAVIGATE_TO_PAYMENT:
            return setActivePage(PAGE_INDICES.PAYMENT);

        default:
            return state;
    }
};
